export const authKeys = {
  me: ['me'] as const,
};
